import { makeAutoObservable, observable, values } from 'mobx'
import { RootStore } from '../RootStore'
import { GoogleFont, IGoogleFont } from './GoogleFont'
import { REACT_APP_READER_URL } from 'env'

export class GoogleFontsStore {
  rootStore: RootStore
  ready = false
  private _fonts = observable.map<IGoogleFont['family'], GoogleFont>()

  /**
   * This is a list of google fonts that we know are not fully supported when
   * parsing them via opentype.js.
   */
  static UNSUPPORTED_FAMILIES = [
    'Alkalami',
    'Baloo Bhai 2',
    'Ballet',
    'Castoro',
    'Chenla',
    'Content',
    'Geist Mono',
    'Harmattan',
    'Jaini Purva',
    'Jaini',
    'Karla Tamil Inclined',
    'Karla Tamil Upright',
    'Khmer',
    'Lateef',
    'MonteCarlo',
    'Noto Sans Duployan',
    'Noto Sans Lycian',
    'Noto Sans Myanmar',
    'Noto Sans Tai Tham',
    'Noto Serif Myanmar',
    'Phetsarath',
    'Piazzolla',
    'Ruwudu',
    'Scheherazade New',
    'Siemreap',
    'Tiro Devanagari Marathi',
    'Tiro Devanagari Sanskrit',
    'Tiro Kannada',
    'Tiro Telugu',
  ]

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)

    this.rootStore = rootStore
  }

  load = (key: IGoogleFont['family']) => {
    const font = this._fonts.get(key)
    if (!font) {
      return
    }

    return font.load()
  }

  get = (key: IGoogleFont['family']) => {
    return this._fonts.get(key)
  }

  get list() {
    return values(this._fonts)
  }

  get supportedList() {
    return this.list.filter((font) => !GoogleFontsStore.UNSUPPORTED_FAMILIES.includes(font.family))
  }

  getByLoadingState = (...states: Array<GoogleFont['loadingState']>) => {
    return this.list.filter((font) => states.includes(font.loadingState))
  }

  addBulk = (items: IGoogleFont[]) => {
    items.forEach((item: IGoogleFont) => {
      this._fonts.set(item.family, new GoogleFont(item))
    })
  }

  fetchAll = async () => {
    try {
      const res = await fetch(`${REACT_APP_READER_URL}/google_fonts`)
      const { items } = await res.json()
      this.addBulk(items)
      this.ready = true
    } catch (error) {}
  }
}
